import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = '';

export const clientSlugSlice = createSlice({
  name: 'clientSlug',
  initialState,
  reducers: {
    setClientSlug: (state, { payload: data }) => {
      return data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setClientSlug } = clientSlugSlice.actions;

export const getClientSlug = (state: RootState) => state.clientSlug;


export default clientSlugSlice.reducer;
